/*
 Copyright (C) 2017 3NSoft Inc.

 This program is free software: you can redistribute it and/or modify it under the terms of the GNU General Public License as published by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.

 This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU General Public License for more details.

 You should have received a copy of the GNU General Public License along with this program. If not, see <http://www.gnu.org/licenses/>. */

export let ModuleName = '3nClient.filter.custom';

export function addFilter(angular: angular.IAngularStatic): void {
  let mod = angular.module(ModuleName, []);
  mod.filter('firstUppercase', firstUppercase);
}

function firstUppercase () {
	return function (item: any) {
		if (!angular.isString(item)) return item;
		return `${item[0].toUpperCase()}${item.substring(1)}`;
	};
}

Object.freeze(exports); 